import React, { useEffect, useState } from 'react';
import { authToken } from '../../authToken';
import { API_BASE_URL } from '../../config';
import NotesAddPanel from './NotesAddPanel';
import NoteItemMenuPanel from './NoteItemMenuPanel';

function NotesPanel({ listId, listName, onClose }) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddPanel, setShowAddPanel] = useState(false);
  const [menuIdx, setMenuIdx] = useState(null);
  const [confirmDeleteIdx, setConfirmDeleteIdx] = useState(null);

  const fetchNotes = () => {
    setLoading(true);
    fetch(`${API_BASE_URL}/notes/for-list/${listId}`, {
      headers: {
  ...(authToken ? { 'Authorization': authToken } : {})
      }
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch notes');
        return res.json();
      })
      .then(data => {
        setNotes(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  };
  useEffect(() => { fetchNotes(); }, [listId]);

  const handleAdd = (content) => {
    fetch(`${API_BASE_URL}/notes/for-list/${listId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
  ...(authToken ? { 'Authorization': authToken } : {})
      },
      body: JSON.stringify({
        name: content,
        done: false
      })
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to add note');
        return res.json();
      })
      .then(() => {
        setShowAddPanel(false);
        fetchNotes();
      })
      .catch(err => {
        setError(err.message);
      });
  };

  return (
    <div style={{
      background: '#fff',
      borderRadius: 16,
      padding: '24px 12px 18px 12px',
      boxShadow: '0 2px 18px rgba(0,0,0,0.22)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      minWidth: 0,
      width: '420px',
      maxWidth: '98vw',
      minHeight: 0,
      height: '650px',
      maxHeight: '96vh',
      overflow: 'auto',
      zIndex: 12000,
      display: 'flex',
      flexDirection: 'column'
    }}>
      <button
        onClick={onClose}
        style={{ position: 'absolute', top: 16, right: 16, fontSize: 24, background: 'none', border: 'none', cursor: 'pointer' }}
        aria-label="Close"
      >✖️</button>
      <h2 style={{ marginBottom: 16 }}>Notatki: {listName}</h2>
      <div style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
        <button
          style={{
            flex: 1,
            padding: '10px 0',
            fontSize: '1.1rem',
            fontWeight: 600,
            borderRadius: 8,
            border: '1px solid #6cf',
            background: '#eaf6ff',
            color: '#227',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
          onClick={() => setShowAddPanel(true)}
        >➕ Dodaj</button>
      </div>
      {loading && <div>Ładowanie...</div>}
      {error && <div style={{ color: 'red' }}>Błąd: {error}</div>}
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {[...notes].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map((note, idx) => (
          <li
            key={note.id || idx}
            style={{
              padding: '12px 0',
              borderBottom: '1px solid #eee',
              fontSize: '1.1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              position: 'relative',
              userSelect: 'none',
            }}
          >
            <span>{note.name}</span>
            <button
              style={{
                background: 'none',
                border: 'none',
                fontSize: 22,
                cursor: 'pointer',
                padding: '0 8px',
                color: '#888',
                marginLeft: 8
              }}
              aria-label="Menu"
              onClick={e => {
                e.stopPropagation();
                setMenuIdx(idx);
              }}
            >
              ⋯
            </button>
            {menuIdx === idx && (
              <NoteItemMenuPanel
                onEdit={() => { setMenuIdx(null); /* TODO: handle edit */ }}
                onDelete={() => { setMenuIdx(null); setConfirmDeleteIdx(idx); }}
                onCancel={() => setMenuIdx(null)}
              />
            )}
            {confirmDeleteIdx === idx && (
              <div style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                background: '#fff',
                borderRadius: 12,
                boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
                padding: 28,
                zIndex: 15000,
                minWidth: 240,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 16
              }}>
                <div style={{ fontSize: '1.1rem', marginBottom: 8 }}>Usunąć notatkę?</div>
                <div style={{ display: 'flex', gap: 16 }}>
                  <button
                    onClick={() => {
                      fetch(`${API_BASE_URL}/notes/${note.id}`, {
                        method: 'DELETE',
                        headers: {
                          ...(authToken ? { 'Authorization': authToken } : {})
                        }
                      })
                        .then(res => {
                          if (!res.ok) throw new Error('Failed to delete');
                          setConfirmDeleteIdx(null);
                          fetchNotes();
                        })
                        .catch(err => {
                          setError(err.message);
                          setConfirmDeleteIdx(null);
                        });
                    }}
                    style={{
                      padding: '10px 24px',
                      fontSize: '1.05rem',
                      fontWeight: 600,
                      borderRadius: 8,
                      border: '1px solid #f66',
                      background: '#fff0f0',
                      color: '#a22',
                      cursor: 'pointer',
                      transition: 'background 0.2s'
                    }}
                  >Usuń</button>
                  <button
                    onClick={() => setConfirmDeleteIdx(null)}
                    style={{
                      padding: '10px 24px',
                      fontSize: '1.05rem',
                      fontWeight: 600,
                      borderRadius: 8,
                      border: '1px solid #bbb',
                      background: '#f8f8f8',
                      color: '#555',
                      cursor: 'pointer',
                      transition: 'background 0.2s'
                    }}
                  >Anuluj</button>
                </div>
              </div>
            )}
          </li>
        ))}
      </ul>
      {!loading && notes.length === 0 && <div>Brak notatek.</div>}

      {showAddPanel && (
        <NotesAddPanel
          onAdd={handleAdd}
          onCancel={() => setShowAddPanel(false)}
        />
      )}
    </div>
  );
}

export default NotesPanel;
